export const OSM_URL = 'https://cdn.devgrid.net/osm/{z}/{x}/{y}.png';
export const SERVICE_API_URL = '/service';
export const USER_SESSION = window.X_SESSION;
export const IS_ROLE_USER = window.X_IS_ROLE_USER;
export const TK305_ALLEGRO_URL = window.X_TK305_ALLEGRO_URL;
export const TK305_MANUAL_URL = window.X_TK305_MANUAL_URL;

// Krakow
export const DEFAULT_LATITUDE = '50.0646501';
export const DEFAULT_LONGITUDE = '19.9449799';
